import ProductDetailsSkeleton from 'catalog/product/pages/product-details.page/skeleton';
import SearchPageSkeleton from 'catalog/product/pages/search.page/skeleton';
import Home from 'common/pages/home.page';
import NotFoundPage from 'common/pages/not-found.page';
import { RouteName } from 'config/constants/route.constants';
import { AppRoutesType } from 'config/types/navigation.type';
import CheckoutSkeleton from 'order/pages/checkout.page/checkout-skeleton';
import PurchaseResult from 'order/pages/purchase-result.page';
import PurchaseResultSkeleton from 'order/pages/purchase-result.page/purchase-result-skeleton';
import React, { Suspense, lazy } from 'react';
import FavoritesPageSkeleton from 'user/pages/my-favorites.page/skeleton';
import MyPurchaseSkeleton from 'user/pages/my-purchases.page/my-purchases-skeleton';
import MyProfile from 'user/pages/profile.page';
import PurchaseDetailsSkeleton from 'user/pages/purchase-details.page/purchase-details-skeleton';
import PrivateRoute from './private.route';

const MyFavoritesPage = lazy(() => import('user/pages/my-favorites.page'));
const SearchPage = lazy(() => import('catalog/product/pages/search.page'));
const ProductDetailsPage = lazy(() => import('catalog/product/pages/product-details.page'));
const MyPurchasesPage = lazy(() => import('user/pages/my-purchases.page'));
const PurchaseDetailsPage = lazy(() => import('user/pages/purchase-details.page'));
const CheckoutPage = lazy(() => import('order/pages/checkout.page'));
const PurchasePaymentProcessingPage = lazy(() => import('order/pages/purchase-payment-processing.page'));

export const routes: AppRoutesType[] = [
  {
    path: RouteName.HOME,
    element: <Home />,
  },
  {
    path: RouteName.SEARCH,
    element: (
      <Suspense fallback={<SearchPageSkeleton />}>
        <SearchPage />
      </Suspense>
    ),
  },
  {
    path: RouteName.PRODUCT_DETAILS,
    element: (
      <Suspense fallback={<ProductDetailsSkeleton />}>
        <ProductDetailsPage />
      </Suspense>
    ),
  },
  {
    path: RouteName.MY_PROFILE,
    element: (
      <PrivateRoute>
        <MyProfile />
      </PrivateRoute>
    ),
  },
  {
    path: RouteName.MY_FAVORITES,
    element: (
      <PrivateRoute>
        <Suspense fallback={<FavoritesPageSkeleton />}>
          <MyFavoritesPage />
        </Suspense>
      </PrivateRoute>
    ),
  },
  {
    path: RouteName.MY_PURCHASES,
    element: (
      <PrivateRoute>
        <Suspense fallback={<MyPurchaseSkeleton />}>
          <MyPurchasesPage />
        </Suspense>
      </PrivateRoute>
    ),
  },
  {
    path: RouteName.PURCHASE_DETAILS,
    element: (
      <PrivateRoute>
        <Suspense fallback={<PurchaseDetailsSkeleton />}>
          <PurchaseDetailsPage />
        </Suspense>
      </PrivateRoute>
    ),
  },
  {
    path: RouteName.PURCHASE_CHECKOUT,
    element: (
      <PrivateRoute>
        <Suspense fallback={<CheckoutSkeleton />}>
          <CheckoutPage />
        </Suspense>
      </PrivateRoute>
    ),
  },
  {
    path: RouteName.PURCHASE_RESULT,
    element: (
      <PrivateRoute>
        <Suspense fallback={<PurchaseResultSkeleton />}>
          <PurchaseResult />
        </Suspense>
      </PrivateRoute>
    ),
  },
  {
    path: RouteName.PURCHASE_PAYMENT_PROCESSING,
    element: (
      <PrivateRoute>
        <Suspense fallback={<PurchaseResultSkeleton />}>
          <PurchasePaymentProcessingPage />
        </Suspense>
      </PrivateRoute>
    ),
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];
